<template>
  <div id="mention-modal" :style="{ top: top, left: left }">
    <input
      id="mention-input"
      v-model="searchVal"
      ref="input"
      placeholder="输入昵称"
      autocomplete="false"
      @keyup="inputKeyupHandler"
    />


    <ul id="mention-list" v-if="list.length > 0">
      <li
        v-for="item in list"
        :key="item.id"
        @click="insertMentionHandler(item.id, item.nickname)"
      >
        {{ item.nickname }}
      </li>
    </ul>


    <el-empty v-else description="暂无人员" :image-size="20"></el-empty>


  </div>
</template>

<script>
import { search } from "@/service/post";
import { getUserByNickname } from "@/service/user";
export default {
  name: "MentionModal",
  props: {
    left: {
      required: true,
    },
    top: {
      required: true,
    },
  },
  data() {
    return {
      // list 信息
      searchVal: "",
      list: [],
    };
  },
  computed: {
    // 根据 <input> value 筛选 list
    searchedList() {
      const searchVal = this.searchVal.trim().toLowerCase();
      return this.list.filter((item) => {
        const name = item.name.toLowerCase();
        if (name.indexOf(searchVal) >= 0) {
          return true;
        }
        return false;
      });
    },
  },
  watch: {
    searchVal(newValue, oldValue) {
      this.fetchData();
    }
  },
  created() {
    this.fetchData();
  },
  mounted() {
    // focus input
    this.$refs.input.focus();
  },
  methods: {
    fetchData() {
      //const id = this.$route.query.id ? this.$route.query.id : -1;
      getUserByNickname({ nickname: this.searchVal })
        .then((response) => {
          this.list = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    inputKeyupHandler(event) {
      // esc - 隐藏 modal
      if (event.key === "Escape") {
        this.$emit("hideMentionModal");
      }

      // enter - 插入 mention node
      if (event.key === "Enter") {
        // 插入第一个
        const firstOne = this.list[0];
        if (firstOne) {
          const { id, nickname } = firstOne;
          this.insertMentionHandler(id, nickname);
        }
      }
    },
    insertMentionHandler(id, nickname) {
      this.$emit("insertMention", id, nickname);
      this.$emit("hideMentionModal"); // 隐藏 modal
    },
  },
};
</script>

<style>
#mention-modal {
  position: absolute;
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 5px;
}

#mention-modal input {
  width: 100px;
  outline: none;
}

#mention-modal ul {
  padding: 0;
  margin: 0;
}

#mention-modal ul li {
  list-style: none;
  cursor: pointer;
  padding: 3px 0;
  text-align: left;
}

#mention-modal ul li:hover {
  text-decoration: underline;
}
</style>
